/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Logo from 'src/components/logo';
import { UI } from 'src/features/transfer/constants';

const LINKS = [
  { label: 'Fees', to: '#fees' },
  { label: 'Terms', to: '/terms' },
  { label: 'Privacy', to: '/privacy' },
];

export default function NewFooter() {
  function renderLink(link) {
    if (link.to.startsWith('#')) {
      return (
        <Box
          key={link.label}
          component="a"
          href={link.to}
          sx={{
            fontSize: 13,
            color: UI.textMuted,
            textDecoration: 'none',
            '&:hover': { color: UI.text },
          }}
        >
          {link.label}
        </Box>
      );
    }
    return (
      <Box
        key={link.label}
        component={RouterLink}
        to={link.to}
        sx={{
          fontSize: 13,
          color: UI.textMuted,
          textDecoration: 'none',
          '&:hover': { color: UI.text },
        }}
      >
        {link.label}
      </Box>
    );
  }

  return (
    <Box component="footer" sx={{ borderTop: `1px solid ${UI.border}` }}>
      <Container maxWidth="lg">
        <Stack direction="row" alignItems="center" sx={{ height: 64 }}>
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
            <Logo width={22} />
          </Box>

          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
            <Typography sx={{ fontSize: 13, color: UI.textMuted }}>
              © {new Date().getFullYear()} SafiSwap
            </Typography>
          </Box>

          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <Stack direction="row" spacing={2.5}>
              {LINKS.map((link) => renderLink(link))}
            </Stack>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
